import { globalStyleObj } from "@/app/assets/styles";
import {
  CommonJoditReactTextEditor,
  CommonTextAreaField,
  CommonTextInputField,
  FileReuseDialog,
  LabelText,
} from "@/components";
import { getFileSettingsValue } from "@/utils/website-settings-helper";
import React from "react";

const InvestmentCommonFields = ({
  theme = "light",
  watchedDescription = "",
  control,
  errors,
  formData,
  filesList,
  allFiles,
  paginationDetails,
  handleOnChangeTextEditor,
  handleOnChangeFile,
  adminRole,
  permissionsList,
  searchValue,
  selectedFileType,
  isItemDetailsExist = false,
  isHideInOtherLanguages = false,
  activeLanguageTab = "en",
}) => {
  return (
    <>
      {/* Name */}
      <CommonTextInputField
        fieldName="name"
        fieldType="text"
        fieldId={
          isItemDetailsExist ? "update-investment-name" : "investment-name"
        }
        control={control}
        errors={errors}
        errorsType={errors?.name}
        placeholderText="Name"
        labelName="Name"
        labelStatus={!isItemDetailsExist}
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Slug */}
      {isHideInOtherLanguages && (
        <CommonTextInputField
          fieldName="slug"
          fieldType="text"
          fieldId={
            isItemDetailsExist ? "update-investment-slug" : "investment-slug"
          }
          control={control}
          errors={errors}
          errorsType={errors?.slug}
          placeholderText="Slug"
          labelName="Slug"
          labelStatus={!isItemDetailsExist}
          extraClass="mt-5"
          inputBoxMaxWidth="xl:max-w-[500px]"
        />
      )}

      {/* Short Description */}
      <CommonTextAreaField
        fieldName="short_description"
        fieldId={
          isItemDetailsExist
            ? "update-investment-short-description"
            : "investment-short-description"
        }
        control={control}
        errors={errors}
        errorsType={errors?.short_description}
        labelName="Short Description"
        placeholderText="Short Description"
        labelStatus={!isItemDetailsExist}
        extraClass="mt-5"
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Description */}
      <CommonJoditReactTextEditor
        value={watchedDescription || ""}
        labelText="Description"
        fieldId={
          isItemDetailsExist
            ? "update-investment-description"
            : "investment-description"
        }
        fieldName="description"
        onTextEditorChange={(content) =>
          handleOnChangeTextEditor(content, "description")
        }
        isItemDetailsExist={isItemDetailsExist}
        extraClass="mt-5"
        inputContainerMaxWidth="xl:max-w-[500px]"
      />

      {/* Featured Image */}
      {isHideInOtherLanguages && (
        <div className={`mt-5 ${globalStyleObj.commonInputContainerClass}`}>
          <LabelText
            text="Featured Image"
            htmlForId={
              isItemDetailsExist
                ? "investment-featured-image"
                : "investment-update-featured-image"
            }
          />

          <div className="flex flex-col gap-2 w-full xl:max-w-[500px]">
            <FileReuseDialog
              htmlId={
                isItemDetailsExist
                  ? "investment-featured-image"
                  : "investment-update-featured-image"
              }
              filesList={filesList}
              allFiles={allFiles}
              paginationDetails={paginationDetails}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeBannerImage={(id) =>
                handleOnChangeFile("featured_image", id)
              }
              selectedBannerFileId={
                isItemDetailsExist
                  ? (getFileSettingsValue(
                      allFiles,
                      formData?.featured_image || ""
                    )?._id ?? null)
                  : null
              }
              selectedBannerFileName={
                isItemDetailsExist
                  ? (getFileSettingsValue(
                      allFiles,
                      formData?.featured_image || ""
                    )?.fileName ?? null)
                  : null
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
            />
          </div>
        </div>
      )}

      {/* Banner Image */}
      {isHideInOtherLanguages && (
        <div className={`mt-5 ${globalStyleObj.commonInputContainerClass}`}>
          <LabelText
            text="Banner Image"
            htmlForId={
              isItemDetailsExist
                ? "investment-banner-image"
                : "investment-update-banner-image"
            }
          />

          <div className="flex flex-col gap-2 w-full xl:max-w-[500px]">
            <FileReuseDialog
              htmlId={
                isItemDetailsExist
                  ? "investment-banner-image"
                  : "investment-update-banner-image"
              }
              filesList={filesList}
              allFiles={allFiles}
              paginationDetails={paginationDetails}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeBannerImage={(id) =>
                handleOnChangeFile("banner_image", id)
              }
              selectedBannerFileId={
                isItemDetailsExist
                  ? (getFileSettingsValue(
                      allFiles,
                      formData?.banner_image || ""
                    )?._id ?? null)
                  : null
              }
              selectedBannerFileName={
                isItemDetailsExist
                  ? (getFileSettingsValue(
                      allFiles,
                      formData?.banner_image || ""
                    )?.fileName ?? null)
                  : null
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
            />
          </div>
        </div>
      )}

      {/* Info Image */}
      {isHideInOtherLanguages && (
        <div className={`mt-5 ${globalStyleObj.commonInputContainerClass}`}>
          <LabelText
            text="Info Image"
            htmlForId={
              isItemDetailsExist
                ? "investment-banner-image"
                : "investment-update-banner-image"
            }
          />

          <div className="flex flex-col gap-2 w-full xl:max-w-[500px]">
            <FileReuseDialog
              htmlId={
                isItemDetailsExist
                  ? "investment-info-image"
                  : "investment-update-info-image"
              }
              filesList={filesList}
              allFiles={allFiles}
              paginationDetails={paginationDetails}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeBannerImage={(id) => handleOnChangeFile("info_image", id)}
              selectedBannerFileId={
                isItemDetailsExist
                  ? (getFileSettingsValue(allFiles, formData?.info_image || "")
                      ?._id ?? null)
                  : null
              }
              selectedBannerFileName={
                isItemDetailsExist
                  ? (getFileSettingsValue(allFiles, formData?.info_image || "")
                      ?.fileName ?? null)
                  : null
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
            />
          </div>
        </div>
      )}

      {/* Button Lable */}
      <CommonTextInputField
        fieldName="button_label"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "update-investment-button-label"
            : "investment-button-label"
        }
        control={control}
        errors={errors}
        errorsType={errors?.button_label}
        placeholderText="Button Label"
        labelName="Button Label"
        extraClass="mt-5"
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Order Number */}
      {isHideInOtherLanguages && (
        <CommonTextInputField
          fieldName="order_number"
          fieldType="text"
          fieldId={
            isItemDetailsExist
              ? "update-investment-order-number"
              : "investment-order-number"
          }
          control={control}
          errors={errors}
          errorsType={errors?.order_number}
          placeholderText="Order Number"
          labelName="Order Number"
          extraClass="mt-5"
          inputBoxMaxWidth="xl:max-w-[500px]"
          extraInformationText="*Enter higher number for the service to be shown on top OR default is 1"
        />
      )}
    </>
  );
};

export default InvestmentCommonFields;
